<div class="announcement-body" [innerHTML]="htmlContent | safeHtml"></div>
